<template>
  <PostboxTeaser
    @click="redirectToPostbox"
    trackId="postboxTeaser"
    :hasHover="true"
    :disableStyles="false"
    :contentCenteredVertically="false"
  >
    <template v-slot:message>
      <span v-if="unreadDocumentCount !== null">
        {{ $t('postboxTile.unreadMessages', { count: unreadDocumentCount }) }}
      </span>
      <span v-if="unreadDocumentCount === null && requestFinished">
        {{ $t('postboxTile.error') }}
      </span>
      <div v-if="unreadDocumentCountBadge !== ''" class="badge badge-postbox">
        {{ unreadDocumentCountBadge }}
      </div>
    </template>

    <template v-slot:button>
      <CustomButton
        v-if="isDa()"
        id="postbox.tile-button.da"
        :button-color="ButtonColor.SECONDARY"
        :button-size="ButtonSize.SMALL"
      >
        <div class="line-height" v-dompurify-html="$t('postboxTile.buttonText')"></div>
      </CustomButton>
      <CustomButton
        v-if="!isDa()"
        id="postbox.tile-button.zur"
        :button-color="ButtonColor.TERTIARY"
        :button-size="ButtonSize.SMALL"
      >
        <div class="line-height" v-dompurify-html="$t('postboxTile.buttonText')"></div>
      </CustomButton>
    </template>
  </PostboxTeaser>
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import {
  ButtonColor,
  ButtonSize,
  CustomButton,
  PostboxTeaser
} from 'de-zurich-ui-library'
import { navigate } from '@/utils/NavigationUtils'
import { getToken } from '@/utils/KeycloakUtils'
import { useI18n } from 'vue-i18n'
import { isDa } from '@/utils/CommonUtils'

const { t } = useI18n()

const props = defineProps({ partnerProxyId: { type: String } })
const unreadDocumentCount = ref<number | null>(null)
const requestFinished = ref(false)

const unreadDocumentCountBadge = computed(() => {
  if (
    unreadDocumentCount.value === undefined ||
    unreadDocumentCount.value === null ||
    unreadDocumentCount.value < 1
  )
    return ''
  if (unreadDocumentCount.value > 9) return '9+'
  return unreadDocumentCount.value.toString()
})

onMounted(async () => {
  try {
    const authToken = await getToken()
    const queryParams = new URLSearchParams({
      partnerProxyId: props.partnerProxyId ?? ''
    })

    const response = await fetch(
      `${globalThis.ENV_CONFIG?.SERVICE_HOSTS.POSTBOX}/documents/unread/count?${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          KeyId: globalThis.ENV_CONFIG?.API_KEY,
          'Content-Type': 'application/json'
        }
      }
    )
    if (response.ok) {
      unreadDocumentCount.value = (await response.json()).unreadDocumentCount
    } else {
      unreadDocumentCount.value = null
    }
  } catch {
    unreadDocumentCount.value = null
  } finally {
    requestFinished.value = true
  }
})

const redirectToPostbox = () => {
  navigate(globalThis.ENV_CONFIG?.REDIRECTS.POSTBOX_PAGE)
}
</script>

<style scoped>
.line-height {
  line-height: 1;
}
</style>
